/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '@swisslife/patterns-base/src/atoms/button/css/button';
import '@swisslife/patterns-base/src/molecules/horizontal-nav/css/horizontal-nav';
import '@swisslife/patterns-base/src/molecules/list-filter/css/list-filter';
import './news-archive.scss';
